import { Component, Input, ViewEncapsulation } from '@angular/core';

/**
 * A Modal Component header.
 * @export
 * @class ModalHeaderComponent
 */
@Component({
  selector: 'pru-modal-header',
  templateUrl: './modal-header.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ModalHeaderComponent {
  /**
   * Unique identifier.
   * @type {string}
   * @memberof ModalHeaderComponent
   */
  @Input() id: string;

  /**
   * Entry point for any custom classes.
   * @type {string}
   * @memberof ModalHeaderComponent
   */
  @Input() cssClass: string;

  /**
   * Determines whether or not the close button should be displayed.
   * @type {boolean}
   * @memberof ModalHeaderComponent
   */
  @Input() hideCloseButton: boolean = false;
}
